import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import BlogManagement from './pages/BlogManagement';
import BlogPost from './pages/BlogPost';
import PDFViewerPage from './pages/PDFViewerPage';
import './styles/motion.css';
import './App.css';

function App() {
  // Re-keying on pathname restarts the fade, so each navigation crossfades.
  const { pathname } = useLocation();

  return (
    <AuthProvider>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main key={pathname} className="page-fade">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/blog-management" element={<BlogManagement />} />
            <Route path="/pdf/:slug" element={<PDFViewerPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}

export default App; 